/**
 * Base class for a generic form layout to consistenly layout a form body and
 * its buttons.
 */

import Marionette from "backbone.marionette";
import templates from "../../utils/templates";

const DEFAULTS = {
  className: "card",
  template: templates.find("generic", "form_layout"),
};

class FormLayout extends Marionette.LayoutView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  regions() {
    return {
      instructions: ".form-instructions",
      body: ".form-fields",
      buttons: ".form-buttons",
    };
  }
}

export { FormLayout as default };
